import styled from "styled-components"

export const InnerContainer = styled.div`
  max-width: 40rem;
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  align-items: stretch;
`



// WEBPACK FOOTER //
// ./src/pages/ResetPassword/styled.js